import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import faviconUrl from './assets/logos/favicon.png';

const link = document.createElement('link');
link.rel = 'icon';
link.type = 'image/png';
link.href = faviconUrl;
document.head.appendChild(link);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
